import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const IconPrev = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const IconNext = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default function B1() {
    const { useLang, useState, useRef } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const [active, setActive] = useState(0);
    const swiperRef = useRef(null) as any;

    const cards: any[] = [
        {
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1786948819749-f03bv9-compressed-002-1.webp',
            imgMobile: 'https://websiteoss.ecoflow.com/figma-uploads/1786948767049-da0eyz-compressed-002-1.webp',
            title: t('secB_tab1'),
            desc: t('secB_tab1_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1786948835126-2ru3a2-compressed-Car%20camping.webp',
            imgMobile: 'https://websiteoss.ecoflow.com/figma-uploads/1786948777787-05rk5c-compressed-002-2.webp',
            title: t('secB_tab2'),
            desc: t('secB_tab2_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1786948847080-ygc7r4-compressed-002-3.webp',
            imgMobile: 'https://websiteoss.ecoflow.com/figma-uploads/1786948802340-0wwzkb-compressed-002-3.webp',
            title: t('secB_tab3'),
            desc: t('secB_tab3_desc'),
        },
    ];

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };
    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    const handlePrev = () => swiperRef.current?.slidePrev();
    const handleNext = () => swiperRef.current?.slideNext();

    return (
        <div id="outdoor-recreation-B" className={`outdoor-recreation-B1 ${css['outdoor-recreation-B1']}`}>
            <div className="oc-carousel">
                <div className="oc-carousel__header">
                    <p className="oc-carousel__title">{t('secB_title')}</p>
                </div>

                <div className="oc-carousel__viewport">
                    <Swiper
                        className="oc-carousel__swiper"
                        slidesPerView={'auto'}
                        centeredSlides={false}
                        slidesOffsetBefore={24}
                        slidesOffsetAfter={24}
                        spaceBetween={12}
                        initialSlide={0}
                        breakpoints={{
                            768: {
                                centeredSlides: false,
                                slidesOffsetBefore: 48,
                                slidesOffsetAfter: 48,
                            },
                            1025: {
                                centeredSlides: true,
                                slidesOffsetBefore: 0,
                                slidesOffsetAfter: 0,
                            },
                        }}
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        onSlideChange={(swiper) => setActive(swiper.activeIndex)}
                    >
                        {cards.map((item: any, k: number) => (
                            <SwiperSlide className={`oc-carousel__slide oc-carousel__slide--${k + 1}`} key={k}>
                                <div className="oc-carousel__img">
                                    <EFPicture src={item.img} srcMobile={item.imgMobile} alt={item.title} />
                                </div>
                                <div className="oc-carousel__body">
                                    <p className="oc-carousel__slide-title">{item.title}</p>
                                    <p className="oc-carousel__slide-desc">{item.desc}</p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <button className="oc-carousel__nav-btn oc-carousel__nav-btn--prev" onClick={handlePrev} aria-label="Previous slide">
                        <IconPrev />
                    </button>
                    <button className="oc-carousel__nav-btn oc-carousel__nav-btn--next" onClick={handleNext} aria-label="Next slide">
                        <IconNext />
                    </button>
                </div>

                <div className="oc-carousel__tabs">
                    <div className="oc-carousel__tabs-inner">
                        {cards.map((card: any, k: number) => (
                            <button
                                key={k}
                                className={`oc-carousel__tab${active === k ? ' oc-carousel__tab--active' : ''}`}
                                onClick={() => {
                                    swiperRef.current?.slideTo(k);
                                    setActive(k);
                                }}
                            >
                                {card.title}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="oc-carousel__mobile">
                    <div className="oc-carousel__mobile-img">
                        <EFPicture src={cards[active]?.imgMobile} alt={cards[active]?.title} />
                    </div>
                    <div className="oc-carousel__mobile-tabs">
                        <ul className="oc-carousel__mobile-list" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                            {cards.map((card: any, k: number) => (
                                <li
                                    className={`oc-carousel__mobile-tab${active === k ? ' oc-carousel__mobile-tab--active' : ''}`}
                                    key={k}
                                    onClick={() => setActive(k)}
                                >
                                    {card.title}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <p className="oc-carousel__mobile-desc">{cards[active]?.desc}</p>
                </div>
            </div>
        </div>
    );
}
